import { InferResponse } from '@/hooks/useApiClient'
import dayjs from 'dayjs'

export const editableFields = ['Total Miles', 'Stops', 'Gallons', 'Loads', 'Drops', 'Deemed Hours']

export type ShiftPayrollFormType = {
  date: string
  driver_id: number
  shiftTimes: [dayjs.Dayjs, dayjs.Dayjs]
  'Total Miles': number
  override_reason: string
}
export type OrderPayrollFormType = {
  date: string
  driver_id: number
  Gallons: number
  Stops: number
  Loads: number
  Drops: number
  'Deemed Hours': number
  override_reason: string | null | undefined
}

export type PayrollPayPeriodResponse = InferResponse<'/payroll/pay_period'>
export type PayPeriodOrderPay = NonNullable<PayrollPayPeriodResponse['rows'][0]['order_pay']>[0]
export type PayPeriodShiftPay = NonNullable<PayrollPayPeriodResponse['rows'][0]['shift_pay']>
